export default __webpack_public_path__ + "static/media/english.b3ff781d.svg";